export enum actionTypes {
    SET_PLAYER_TAGS = 'IDENTT_MANUAL:PLAYER_TAGS:SET',
    SET_LOADING_ERROR = 'IDENTT_MANUAL:LOADING_ERROR:SET'
}
